import Loadable from '../../components/loadable';

const SentBulkMessages = Loadable({
  loader: () => import('../../pages/messages/sent_bulk_messages'),
  type: 'block',
});

angular.module('gym').value('SentBulkMessages', SentBulkMessages);

const SentBulkMessagesFiltersModal = Loadable({
  loader: () => import('../../pages/messages/sent_bulk_messages/sent_bulk_messages_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('SentBulkMessagesFiltersModal', SentBulkMessagesFiltersModal);

const SentBulkMessageDetailsDrawer = Loadable({
  loader: () => import('../../pages/messages/sent_bulk_messages/sent_bulk_message_details_drawer'),
  type: 'drawer',
});

angular.module('gym').value('SentBulkMessageDetailsDrawer', SentBulkMessageDetailsDrawer);
